module.exports = __webpack_public_path__ + "325008036c696f75fde20369a9ec3f70.svg";